import type { FaireProductEntity } from "../../entity_types/product";

export const p_r86f5gkb5f: FaireProductEntity = {
  token: "p_r86f5gkb5f",
  type: "product",
  name: "Padangbai Beaded Surfer Necklace, White Beachy Choker",
  brandName: "Pineapple Island",
  imageUrl:
    "https://cdn.faire.com/fastly/e2c51607ac8adcf18ff6447b8022a70e557ba7b5eb722ac34bfc113d1aa77503.jpeg",
  priceDollars: 5.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0193d1d2c59385c27107b0c57a7aed1727f42362d6a757e5c0b72e25554aa2b7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
